import { TableColumnsType } from "antd";
import { BasePagination } from "api/interfaces/commonInterface.interface";
import {
  FeaturesPopupData,
  FeaturesPopupListData,
} from "api/interfaces/settingsInterface.interface";
import { CommonTable } from "components/atoms/table/AntdTable";
import { TableTemplate } from "components/templates/default/table/TableTemplate";
import AddFeaturesModal from "./add";
import FeaturesPopup from "components/blocks/announcement/FeaturesPopup";
import Status, { StatusType } from "components/blocks/status/Status";

type Props = {
  titleComponent: string;
  queryInfo: BasePagination;
  onClickSearch: (keyword: string) => void;
  buttonLabel: string;
  columns: TableColumnsType<FeaturesPopupListData>;
  data: Array<FeaturesPopupListData>;
  onChangePage: (page: number, totalRows: number) => void;
  isLoading: boolean;
  onModal: (type: string, row?: FeaturesPopupListData) => void;
  refetch: () => void;
  isAddFeaturesModal: boolean;
  selectedData: FeaturesPopupData;
  setSelectedData: React.Dispatch<React.SetStateAction<FeaturesPopupData>>;
  isViewFeaturesModal: boolean;
  status: StatusType;
};

export default function FeaturesPopupPresenter(props: Props) {
  return (
    <>
      <TableTemplate
        titleComponent={props.titleComponent}
        keyword={props.queryInfo.keyword}
        onClickSearch={props.onClickSearch}
        buttonLabel={props.buttonLabel}
        centerChildren={<Status status={props.status} />}
        onClickBtn={() => {
          props.onModal("add");
        }}
        data-testid="manager-features-features-table-template-modal"
      >
        <CommonTable
          columns={props.columns}
          dataSource={props.data}
          queryInfo={props.queryInfo}
          onChangePage={props.onChangePage}
          loading={props.isLoading}
        />
      </TableTemplate>
      {props.isAddFeaturesModal && (
        <AddFeaturesModal
          onModal={() => props.onModal("add")}
          onClickPreview={() => props.onModal("preview")}
          data={props.selectedData}
          setData={props.setSelectedData}
        />
      )}

      {props.isViewFeaturesModal && (
        <FeaturesPopup
          onModal={() => props.onModal("preview")}
          data={props.selectedData}
        />
      )}
    </>
  );
}
